<template>
  <BreadCrumb PageTitle="Gestion des agences" />
  <AgenciesSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AgenciesSettings from "../../components/Generals/Zones/AgenciesSettings.vue";

export default defineComponent({
  name: "AgenciesSettingsPage",
  components: {
    BreadCrumb,
    AgenciesSettings,
  },
});
</script>